import axios from 'frontend/_config/axios'
import setupRouter from 'frontend/_setup/setupRouter/setupRouter'
import { ResourceService } from 'frontend/common/services/resource-service'
import { SimpleSelectService } from 'frontend/common/services/simple-select-service'

export class VehicleModelsService extends ResourceService {
  constructor({
    eventSlug = setupRouter.currentRoute.value.params.eventSlug,
    baseUrl = eventSlug?.length ? `/events/${eventSlug}/vehicle_models` : `/vehicle_models`,
    blocker,
    blockerKey = 'vehicle_models',
    fetchError = 'Failed to fetch vehicle model.',
    saveError = 'Failed to save vehicle model.',
    apiProvider = axios,
    selectService = new SimpleSelectService(baseUrl, {
      apiProvider,
      blocker,
      blockerKey,
    }),
  } = {}) {
    super({
      apiProvider,
      baseUrl,
      blocker,
      blockerKey,
      fetchError,
      saveError,
    })
    this.selectService = selectService
  }

  get getForSelect() {
    return () =>
      this.selectService.fetchOptions({
        fields: [
          'id',
          'name',
          {
            vehicle_models: ['id', 'name'],
          },
        ],
        path: `${this.selectService.baseUrl}/selection_index`,
      })
  }

  get getWithBrandsForSelect() {
    return (additionalPayload = {}) =>
      this.selectService.fetchOptions({
        additionalPayload,
        fields: [
          'id',
          'name',
          {
            vehicle_brand: ['id', 'name'],
          },
        ],
        path: `${this.selectService.baseUrl}/selection_index`,
      })
  }
}
